//
//
//
//
//
//
//
//

import Home from './components/Home.vue'

export default {
  name: 'app',
  components: {
    Home,
  },
  computed: {
    className() {
      return 'is-' + this.$route.name
    }
  }
}
